import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { getTeamSettings } from '@/lib/formatters';
import { DEFAULT_THEME_COLOR, normalizeThemeColor } from '@shared/types/theme';

export function applyThemeColor(themeColor: string) {
  document.documentElement.setAttribute('data-theme-color', themeColor);
}

/**
 * Applies the active team's named ShadCN palette to the document root.
 */
export function TeamThemeProvider({ children }: { children: React.ReactNode }) {
  const activeTeamId = useAuthStore((state) => state.user?.active_team?.id);
  const activeThemeColor = useAuthStore(
    (state) => state.user?.active_team?.settings?.themeColor
  );

  useEffect(() => {
    const settings = getTeamSettings();
    applyThemeColor(normalizeThemeColor(settings.themeColor ?? activeThemeColor ?? DEFAULT_THEME_COLOR));
  }, [activeTeamId, activeThemeColor]);

  return <>{children}</>;
}
